import {Injectable} from '@angular/core';
import {OfflineNodeApiService} from '../../../../services/api/network/offline/node/offline-node-api.service';
import {OfflinePeerConnectionApiService} from '../../../../services/api/network/offline/peer-connection/offline-peer-connection-api.service';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class OfflineTestRouteService {

  constructor(private offlineNodeApiService: OfflineNodeApiService,
              private offlinePconApiService: OfflinePeerConnectionApiService) {
  }

  constructDataForTestRouteGrid(success, testRouteResult): void {
    if (Array.isArray(testRouteResult.paths)) {
      testRouteResult.paths.forEach((path) => {
        path.srcPeerConnection = testRouteResult.srcPeerConnection;

        this.offlineNodeApiService.getNode(path.destNode).then(node => {
          path.destNodeName = node.name;
          if (path.destPeerConnection !== -1) {
            this.offlinePconApiService.getPcon(path.destPeerConnection).then(pCon => {
              path.destPeerConnectionName = pCon.name;
            });
          }
        });
      });
    }

    if (testRouteResult.httpResponse !== 200 ||
        (_.isNil(testRouteResult.paths) &&
            this.notDiscard(testRouteResult))) {
      testRouteResult.paths = [];
      testRouteResult.noRoutesFound = true;
      success(testRouteResult);
    } else {
      if (testRouteResult.paths !== null && testRouteResult.paths.length > 0) {
        let selectedRulesCounter = 0;
        let unselectedRulesCounter = 0;
        for (let i = 0; i < testRouteResult.paths.length; i++) {
          testRouteResult.paths[i].routingRuleName = testRouteResult.paths[i].rrName;
          testRouteResult.paths[i].routingGroupName = testRouteResult.paths[i].rrGroupName;
          testRouteResult.paths[i].numOfEdges = testRouteResult.paths[i].edges !== null ? testRouteResult.paths[i].edges.length : 0;
          testRouteResult.paths[i].discarded = false;
          if (!testRouteResult.paths[i].unselectedRule) {
            selectedRulesCounter++;
            testRouteResult.paths[i].path = 'path ' + (selectedRulesCounter);
          }
          else{
            unselectedRulesCounter++;
            testRouteResult.paths[i].path = 'Unselected Path ' + (unselectedRulesCounter);
          }
        }
      }

      if (testRouteResult.discardingByRoutingRule !== -1) {
        const pathIndex = testRouteResult.paths !== null && testRouteResult.paths.length > 0 ? testRouteResult.paths.length : 0;
        const pathRecord = {
          routingRuleName: testRouteResult.discardingByRrName,
          routingGroupName: testRouteResult.discardingByRrGroupName,
          numOfEdges: 'Discarded',
          path: 'path ' + (pathIndex + 1),
          discarded: true
        };
        if (testRouteResult.paths === null) {
          testRouteResult.paths = [];
        }
        testRouteResult.paths.push(pathRecord);
      }

      if (testRouteResult.continueWithNodeInternalTablesByRoutingRule !== -1) {
        const pathIndex = testRouteResult.paths !== null && testRouteResult.paths.length > 0 ? testRouteResult.paths.length : 0;
        const pathRecord: any = {
          routingRuleName: testRouteResult.continueWithNodeInternalTablesgByRrName,
          routingGroupName: testRouteResult.continueWithNodeInternalTablesByRrGroupName,
          numOfEdges: 'Continue',
          path: 'path ' + (pathIndex + 1),
          destNode: testRouteResult.srcNode,
          destPeerConnection: testRouteResult.srcPeerConnection,
          discarded: false,
          edges: null
        };

        if (testRouteResult.paths === null) {
          testRouteResult.paths = [];
        }

        testRouteResult.paths.push(pathRecord);
      }

      success(testRouteResult);
    }
  }

  constructTestRouteData(success, testRoute): void {
    Promise.all([this.offlineNodeApiService.getNode(testRoute.srcNode), this.offlinePconApiService.getPcon(testRoute.srcPeerConnection)])
      .then(data => {
        testRoute.srcNodeName = data[0].name;
        testRoute.srcPeerConnectionName = data[1].name;
        success(testRoute);
      });
  }

  constructDataForTestRouteDetailsGrid(testRouteResult, selectedPaths): any {
    const result = [];
    if (testRouteResult && testRouteResult.preRouteManipulationsList != null) {
      testRouteResult.preRouteManipulationsList.forEach((manipulation) => {
        manipulation.manipulationsList.forEach((innerManipulation) => {
          const preManipulationRecord = this.buildTestRouteManipulationRecord(manipulation, innerManipulation, 'Before route');
          result.push(preManipulationRecord);
        });
      });
    }

    if (selectedPaths && selectedPaths.length > 0) {
      const selectedPath = selectedPaths[0];
      const pathRouteManipulationsList = selectedPath.pathRouteManipulationsList;
      if (pathRouteManipulationsList) {
        pathRouteManipulationsList.forEach((manipulation) => {
          manipulation.manipulationsList.forEach((innerManipulation) => {
            const pathManipulationRecord = this.buildTestRouteManipulationRecord(manipulation, innerManipulation, 'During route');
            result.push(pathManipulationRecord);
          });
        });
      }
    }
    return result;
  }

  private buildTestRouteManipulationRecord(manipulation, manipulationInner, manipulationType): any {
    const changedTemplateClasses = ['blue-text-color', 'bold-text'];
    return {
      color: manipulationInner.changed ? changedTemplateClasses : [],
      manipulationType,
      manipulatedEntity: manipulation.manipulatedEntity === null ? '' : manipulation.manipulatedEntity,
      manipulatingEntity: manipulationInner.manipulatingEntityName,
      usingManipulatingEntity: manipulationInner.usingManipulatingEntityName === null ? '' : manipulationInner.usingManipulatingEntityName,
      originalValue: manipulationInner.originalValue === null ? '' : manipulationInner.originalValue,
      manipulatedValue: manipulationInner.manipulatedValue === null ? '' : manipulationInner.manipulatedValue,
      unselectedRuleDescription: manipulationInner.unselectedRuleDescription === null ? '' : manipulationInner.unselectedRuleDescription,
      usedInRouting: manipulationInner.unselectedRule === null ? 'Yes' : (!manipulationInner.unselectedRule ? 'Yes' : 'No')
    };
  }

  private notDiscard(testRouteResult): boolean {
    return (_.isNil(testRouteResult.discardingByRoutingRule) || testRouteResult.discardingByRoutingRule === -1) &&
        _.isNil(testRouteResult.discardingByRrGroupName) &&
        _.isNil(testRouteResult.discardingByRrName);
  }
}
